import { render } from "./Loader.vue?vue&type=template&id=7fcf4118&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=7fcf4118&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fcf4118"

export default script